import { QueryKey, useMutation } from '@tanstack/react-query';
import { User } from 'api/types';
import { AxiosError } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

export function useBlockUserMutation(userId: number) {
  const axios = useAxios();
  return useMutation<User, AxiosError<{ message: string }>, { task_reassign_user_id: number }>({
    mutationKey: getKey(userId),
    mutationFn: async (data) => axios.put(`${config.apiBaseUrl}/op/v1/users/${userId}/block`, data),
  });
}

export function getKey(userId: number) {
  return ['BlockUser', userId] as const satisfies QueryKey;
}
